<template>
  <section class="my-30">
    <Container>
      <SectionHeader>Presented by</SectionHeader>
      <div>
        <div class="space-y-12 mb-25">
          <ContactAgent
            v-if="getAgent"
            :data="getAgent"
          />
          <ContactAgent :data="agent" v-for="agent in getMultiAgents" :key="agent.id" />
        </div>
      </div>
      <div>
        <SectionHeader>Contact</SectionHeader>
        <div class="mx-auto w-full max-w-3xl">
          <ContactForm />
        </div>
      </div>
    </Container>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';

  import SectionHeader from '../../components/SectionHeader';
  import ContactAgent from './components/ContactAgent';
  import ContactForm from './components/ContactForm';
  import Container from '../../components/Container';
  import addressMixin from '@/shared/mixins/address';

  export default {
    name: 'Contact',
    mixins: [
      addressMixin
    ],
    components: {
      SectionHeader,
      ContactAgent,
      ContactForm,
      Container
    },
    computed: {
      ...mapGetters('tour', ['getAgent', 'getMultiAgents', 'getPrimaryColor'])
    }
  };
</script>
